import { Chapter } from '../question/question.model';

export enum SubjectType {
  LowerForm = 'lower-form',
  UpperForm = 'upper-form',
  Elementary = 'elementary',
  All = '',
}

export enum SubjectLevel {
  LowerForm = 'Menengah Rendah',
  UpperForm = 'Menengah Atas',
  Elementary = 'Sekolah Rendah',
}

export enum SubjectTypeFriendlyValue {
  'lower-form' = 'lower form',
  'upper-form' = 'upper form',
  'elementary' = 'elementary',
}
export interface Subject {
  id: number;
  uuid: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  languages: QuestionLanguage[];
  forms: Form[];
  chapters: Chapter[];
  subjectTypes: SubjectType[];
  isAvailLowerForm: boolean;
  isAvailUpperForm: boolean;
  isAvailElementary: boolean;
  isNoLevel: boolean;
}

export interface Form {
  index: number;
  chapters: Chapter[];
}
export interface SubjectDetail {
  id: number;
  uuid: string;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  chapters: Chapter[];
  isAvailable: boolean;
}

export enum QuestionLanguage {
  english = 'english',
  malay = 'malay',
}
